import styled, { css } from 'styled-components'

export const ProfileTitle = styled.h2`
  font-size: 22px;
  margin-bottom: 20px;
  color: #555;
`

export const Wrapper = styled.div``

export const CardWrapper = styled.div`
  @media (min-width: 1170px) {
    .col-6 {
      width: 50%;
    }
  }
`

export const CardBox = styled.div`
  padding: 8px 16px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;

  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;

  .iconCredit {
    background-color: blue;
    display: flex;
    align-items: center;
    width: 70px;

    @media (max-width: 480px) {
      width: 28px;
    }
  }

  .credit-icon {
    background-color: #d22630;
    width: 70px;
  }
`

export const MainCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  label {
    position: absolute;
    display: flex;
    align-items: center;
    margin-top: -17px;
  }
`

export const CardInfo = styled.div`
  justify-self: left;
  font-size: 14px;
  margin-left: 16px;
  margin-right: 8px;
  width: 240px;
  flex: 1;

  p > p {
    color: #707070;
  }
  strong {
    font-weight: 600;
  }

  select.parcelas {
    padding: 4px 30px 4px 16px;
    max-width: 260px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
    margin-left: 8px;
  }
`

export const CardIcon = styled.a`
  transition: all 400ms;
  right: 22px;
  /* flex: 1; */
  text-align: right;

  & img {
    width: 18px;
    height: 21px;
    cursor: pointer;

    &:hover {
      filter: invert(22%) sepia(78%) saturate(2710%) hue-rotate(341deg)
        brightness(88%) contrast(96%);
    }

    @media (max-width: 480px) {
      width: 16px;
    }
  }
`
